export default __webpack_public_path__ + "static/media/sketch.87c83552.svg";